import { Helmet } from "react-helmet-async";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string;
  type?: "website" | "article";
}

const ORIGIN = (import.meta.env.VITE_SITE_URL || "https://provenance365.com").replace(/\/$/, "");
const OG_IMAGE = `${ORIGIN}/og-deal-position.png`;

export const SeoHead = ({ title, description, path, type = "website" }: SeoHeadProps) => {
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1730" />
      <meta property="og:image:height" content="909" />
      <meta property="og:image:alt" content="PROVENANCE 365 — Deal-ready is not a scan result." />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content="PROVENANCE 365 — Deal-ready is not a scan result." />
    </Helmet>
  );
};
